import { Routes } from '@angular/router';
import { StatisticsComponent } from './statistics/statistics/statistics.component';  
import { OrderDetailsComponent } from './orders/order-details/order-details.component';
import { OrderListComponent } from './orders/order-list/order-list.component';
import { LocationEditorComponent } from './locations/location-editor/location-editor.component';
import { LocationListComponent } from './locations/location-list/location-list.component';
import { PhotoPricesComponent } from './photo-prices/photo-prices.component';
import { UserListComponent } from './users/user-list/user-list.component';
import { UserDetailsComponent } from './users/user-details/user-details.component';
import { NewsListComponent } from './news/news-list/news-list.component';
import { NewsEditorComponent } from './news/news-editor/news-editor.component';
import { NewOperatorComponent } from './users/new-operator/new-operator.component';
import { CustomerList } from './customers/customer-list/customer-list';
import { CustomerDetails } from './customers/customer-details/customer-details';

export const mainRoutes: Routes = [
  { path: 'orders/:id', component: OrderDetailsComponent },  // More specific route first
  { path: 'orders', component: OrderListComponent },         // Less specific route second
  { path: 'statistics', component: StatisticsComponent },
  { path: 'locations/new', component: LocationEditorComponent },  // Before :id route
  { path: 'locations/:id', component: LocationEditorComponent },
  { path: 'locations', component: LocationListComponent }, 
  { path: 'photo-price', component: PhotoPricesComponent },
  { path: 'users/:id', component: UserDetailsComponent },
  { path: 'customers/:id', component: CustomerDetails },
  { path: 'customers', component: CustomerList },
  { path: 'news/editor', component: NewsEditorComponent },
  { path: 'news/:id', component: NewsEditorComponent },
  { path: 'news', component: NewsListComponent },
  { path: 'operators/new', component: NewOperatorComponent },  // Add before :id route
  { path: 'operators/:id', component: UserDetailsComponent },
  { path: 'operators', component: UserListComponent },
  { path: '', redirectTo: 'orders', pathMatch: 'full' }
];